//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SfTabs, SfInput, SfButton } from "@storefront-ui/vue";
export default {
  name: "SfMyProfile",
  components: {
    SfTabs,
    SfInput,
    SfButton
  },
  props: {
    tabsTitles: {
      type: Array,
      default: () => ["Personal data", "Password change"]
    },
    account: {
      type: Object,
      default: () => ({})
    },
    personalInputsLabels: {
      type: Array,
      default: () => ["First Name", "Last Name", "Your e-mail"]
    },
    passwordInputsLabels: {
      type: Array,
      default: () => ["Current Password", "New Password", "Repeat Password"]
    },
    personalDataDescription: {
      type: String,
      default:
        "Feel free to edit any of your details below so your account is always up to date"
    },
    saveButtonText: {
      type: String,
      default: "Save changes"
    },
    updateButtonText: {
      type: String,
      default: "Update password"
    }
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      currentPassword: "",
      newPassword: "",
      repeatPassword: "",
      openTab: 1
    };
  },
  watch: {
    account: {
      handler(value) {
        this.firstName = value.firstName;
        this.lastName = value.lastName;
        this.email = value.email;
      },
      immediate: true
    }
  },
  methods: {
    updatePersonal() {
      const personal = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email
      };
      this.$emit("update:personal", personal);
    },
    updatePassword() {
      const password = {
        password: this.newPassword
      };
      this.$emit("update:password", password);
    },
    changeTab(tab) {
      this.openTab = tab;
    }
  }
};
